import { render, staticRenderFns } from "./OrderAdm.vue?vue&type=template&id=2695a450&scoped=true&"
import script from "./OrderAdm.vue?vue&type=script&lang=js&"
export * from "./OrderAdm.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdm.vue?vue&type=style&index=0&id=2695a450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695a450",
  null
  
)

export default component.exports